module.exports = __webpack_public_path__ + "static/media/Faith Based Active.9bb6d7a2.svg";